import React from 'react';
import { shortnameToUnicode } from "emoji-toolkit";
import truncate from "lodash/truncate";

import MaterialIcon from "shared/react_components/MaterialIcon";

import { notificationType } from './../shared_proptypes';

const CommentNotification = ({ notification }) => {
  const { message, commentText } = notification;
  const commentTextWithEmojis = shortnameToUnicode(commentText);
  return (
    <span className="notification-item" data-test-id="notification_template">
      <MaterialIcon name="message" className="notification-item__status" />
      <div className="notification-item__details">
        <span className="notification-dropdown__item-title" data-test-id="message">{message}</span>
        <span className="notification-dropdown__item-message" data-test-id="comment">
          {truncate(commentTextWithEmojis, { length: 75 })}
        </span>
      </div>
    </span>
  );
};

CommentNotification.propTypes = {
  notification: notificationType().isRequired
};

export default CommentNotification;
